// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import { ApiResponse, UserDelegationRecord } from './types/types';

// Define a service using a base URL and expected endpoints
export const userDelegationsAPI = createApi({
  reducerPath: 'userDelegationsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getUserDelegations: builder.query<UserDelegationRecord[], void>({
      query: () => ({
        url: `/auth/userdelegation`,
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<UserDelegationRecord[]>) => response.body,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUserDelegationsQuery } = userDelegationsAPI;
